import { action } from 'satcheljs';
import ServicesRequestStatus from '../store/schema/ServicesRequestStatus';

/**
 * Action to update current services getting state.
 */
let setGetServicesState = action(
    'SET_GET_PBP_SERVICES_STATE',
    (getServicesRequestStatus: ServicesRequestStatus) => ({
        getServicesRequestStatus,
    })
);

export default setGetServicesState;
